import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';

const TermsOfServiceModal = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-slate-400 hover:text-white cursor-pointer">
          Όροι Χρήσης
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center greek-font">
            ⚖️ Όροι Χρήσης & Νομικές Διευκρινίσεις
          </DialogTitle>
          <p className="text-center text-gray-600">Τελευταία ενημέρωση: 23/8/2025</p>
        </DialogHeader>
        
        <div className="space-y-6 text-sm">
          <div className="bg-red-50 border border-red-200 p-4 rounded-lg">
            <h3 className="text-lg font-bold text-red-800 mb-2">⚠️ ΣΗΜΑΝΤΙΚΕΣ ΝΟΜΙΚΕΣ ΔΙΕΥΚΡΙΝΙΣΕΙΣ ⚠️</h3>
            <p className="text-red-700">Με τη χρήση του ΝΟΜΟΚΡΑΤΙΑ αποδέχεστε πλήρως αυτούς τους όρους.</p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">Άρθρο 1. ΑΠΟΥΣΙΑ ΝΟΜΙΚΩΝ ΣΥΜΒΟΥΛΩΝ</h3>
            <div className="bg-red-100 border border-red-300 p-3 rounded mb-3">
              <h4 className="font-bold text-red-800">🚨 ΘΕΜΕΛΙΩΔΗΣ ΑΠΟΚΛΕΙΣΜΟΣ ΕΥΘΥΝΩΝ:</h4>
              <p className="text-red-700">Η πλατφόρμα ΝΟΜΟΚΡΑΤΙΑ παρέχει ΑΠΟΚΛΕΙΣΤΙΚΑ γενικές πληροφοριακές υπηρεσίες και ΔΕΝ ΠΑΡΕΧΕΙ ΝΟΜΙΚΕΣ ΣΥΜΒΟΥΛΕΣ κατά την έννοια του νόμου περί νομικών υπηρεσιών.</p>
            </div>
            
            <h4 className="font-semibold mb-2">Ευρωπαϊκές Νομικές Διατάξεις:</h4>
            <ul className="list-disc list-inside mb-3 space-y-1">
              <li>Οδηγία ΕΕ 2006/123/ΕΚ (Οδηγία Υπηρεσιών): Η υπηρεσία μας εμπίπτει στις γενικές πληροφοριακές υπηρεσίες, όχι στη ρυθμιζόμενη νομική συμβουλευτική</li>
              <li>Κανονισμός ΕΕ 2016/679 (ΓΚΠΔ) Άρθρο 13: Διαφανής ενημέρωση για την επεξεργασία δεδομένων και τα όρια των υπηρεσιών</li>
              <li>Οδηγία 2000/31/ΕΚ (Οδηγία Ηλεκτρονικού Εμπορίου): Διευκρίνιση του τύπου υπηρεσίας για ηλεκτρονικές υπηρεσίες</li>
            </ul>

            <h4 className="font-semibold mb-2">Ελληνικές Νομικές Διατάξεις:</h4>
            <ul className="list-disc list-inside space-y-1">
              <li>Νόμος 4194/2013 (Κώδικας Δικηγόρων): Η νομική συμβουλευτική επιτρέπεται αποκλειστικά σε αδειοδοτημένους δικηγόρους</li>
              <li>Άρθρο 7 ΚΔικ: Απαγόρευση παροχής νομικών συμβουλών από μη-δικηγόρους</li>
              <li>Νόμος 2971/2001 (Προστασία Καταναλωτή): Προστασία από παραπλανητικές υπηρεσίες</li>
              <li>Αστικός Κώδικας Άρθρο 914: Αποκλεισμός ευθύνης για πληροφοριακές υπηρεσίες</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">Άρθρο 2. ΠΕΡΙΟΡΙΣΜΟΙ ΣΥΣΤΗΜΑΤΟΣ ΤΕΧΝΗΤΗΣ ΝΟΗΜΟΣΥΝΗΣ</h3>
            <h4 className="font-semibold mb-2">Τεχνικοί Περιορισμοί:</h4>
            <ul className="list-disc list-inside mb-3 space-y-1">
              <li>Οι απαντήσεις που παράγονται από την AI μπορεί να περιέχουν σφάλματα, ανακρίβειες ή παρωχημένες πληροφορίες</li>
              <li>Το σύστημα δεν λαμβάνει υπόψη τις ατομικές περιστάσεις της υπόθεσής σας</li>
              <li>Οι νομικές διατάξεις υπόκεινται σε συνεχείς αλλαγές - η επικαιρότητα δεν εγγυάται</li>
              <li>Η AI δεν μπορεί να κατανοήσει πλήρως το νομικό πλαίσιο και τις αποχρώσεις</li>
            </ul>
            
            <h4 className="font-semibold mb-2">Δικαστικές Προεκδικαστικές Υποθέσεις:</h4>
            <p>Τα αναφερόμενα ECLI κρίσεις χρησιμεύουν μόνο για γενική ενημέρωση. Κάθε υπόθεση είναι μοναδική - παρελθούσες αποφάσεις δεν εγγυώνται μελλοντικές αποφάσεις.</p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">Άρθρο 3. ΠΛΗΡΗΣ ΑΠΟΚΛΕΙΣΜΟΣ ΕΥΘΥΝΩΝ</h3>
            <div className="bg-red-100 border border-red-300 p-3 rounded mb-3">
              <h4 className="font-bold text-red-800">🛑 ΑΠΟΛΥΤΗ ΑΠΑΛΛΑΓΗ ΕΥΘΥΝΩΝ:</h4>
              <p className="text-red-700">Η PROTOS AI Agency IKE και η πλατφόρμα ΝΟΜΟΚΡΑΤΙΑ ΔΕΝ ΑΝΑΛΑΜΒΑΝΟΥΝ ΚΑΜΙΑ ΕΥΘΥΝΗ για:</p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <h4 className="font-semibold mb-2">Άμεσες Ζημίες:</h4>
                <ul className="list-disc list-inside space-y-1">
                  <li>Λανθασμένες νομικές εκτιμήσεις</li>
                  <li>Χαμένες προθεσμίες ή ραντεβού</li>
                  <li>Χαμένες δικαστικές διαδικασίες</li>
                  <li>Οικονομικές απώλειες</li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold mb-2">Έμμεσες Ζημίες:</h4>
                <ul className="list-disc list-inside space-y-1">
                  <li>Χαμένα κέρδη</li>
                  <li>Ζημίες φήμης</li>
                  <li>Παρεπόμενες ζημίες κάθε είδους</li>
                  <li>Κόστος ευκαιρίας</li>
                </ul>
              </div>
            </div>
            <p className="mt-3 text-sm"><strong>Νομική Βάση:</strong> Βασιζόμενοι στην Οδηγία ΕΕ 2000/31/ΕΚ Άρθρα 12-15 και στο ελληνικό αστικό δίκαιο (ΑΚ 914-918), ως καθαρή πληροφοριακή πλατφόρμα δεν αναλαμβάνουμε ευθύνη για τις αποφάσεις των χρηστών.</p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">Άρθρο 4. ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΝΟΜΙΚΗ ΣΥΜΒΟΥΛΕΥΤΙΚΗ ΑΠΑΡΑΙΤΗΤΗ</h3>
            <div className="bg-green-100 border border-green-300 p-3 rounded mb-3">
              <h4 className="font-bold text-green-800">✅ ΕΠΕΙΓΟΥΣΑ ΣΥΣΤΑΣΗ:</h4>
              <p className="text-green-700">Για όλα τα νομικά θέματα συμβουλευτείτε ΠΑΝΤΑ έναν αδειοδοτημένο δικηγόρο!</p>
            </div>
            
            <p className="mb-2">Η δικηγορική συμβουλευτική είναι ΑΠΑΡΑΙΤΗΤΗ σε:</p>
            <div className="grid md:grid-cols-3 gap-2">
              <ul className="list-disc list-inside text-sm space-y-1">
                <li>Δικαστικές διαδικασίες</li>
                <li>Σύνταξη συμβολαίων</li>
                <li>Διαζύγια</li>
                <li>Κληρονομικά θέματα</li>
              </ul>
              <ul className="list-disc list-inside text-sm space-y-1">
                <li>Ποινικές διαδικασίες</li>
                <li>Εργατικό δίκαιο</li>
                <li>Ακίνητα</li>
                <li>Εταιρικό δίκαιο</li>
              </ul>
              <ul className="list-disc list-inside text-sm space-y-1">
                <li>Φορολογικό δίκαιο</li>
                <li>Διαδικασίες πτώχευσης</li>
                <li>Διεθνή νομικά θέματα</li>
                <li>Σύνθετες νομικές υποθέσεις</li>
              </ul>
            </div>

            <div className="mt-4 p-3 bg-slate-50 border border-slate-200 rounded">
              <h4 className="font-bold mb-2">🏛️ Επικοινωνίες για επαγγελματική βοήθεια:</h4>
              <ul className="text-sm space-y-1">
                <li>• Δικηγορικός Σύλλογος Αθηνών: www.dsa.gr | +30 210 3616939</li>
                <li>• Δικηγορικός Σύλλογος Θεσσαλονίκης: www.dst.gr | +30 2310 287820</li>
                <li>• Νομική βοήθεια ΕΕ: europa.eu/citizens/legal-help</li>
              </ul>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">Άρθρο 5. ΟΡΟΙ ΧΡΗΣΗΣ ΥΠΗΡΕΣΙΑΣ</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <h4 className="font-semibold mb-2 text-green-700">Επιτρεπόμενη Χρήση:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Γενικές νομικές πληροφορίες για προσωπική εκπαίδευση</li>
                  <li>Πρώτος προσανατολισμός σε νομικά ερωτήματα</li>
                  <li>Έρευνα για νόμους και αποφάσεις</li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-red-700">Απαγορευμένη Χρήση:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Αντικατάσταση δικηγορικής συμβουλευτικής</li>
                  <li>Βάση για νομικές αποφάσεις</li>
                  <li>Χρήση σε δικαστικές διαδικασίες ως απόδειξη</li>
                  <li>Εμπορική επαναχρησιμοποίηση χωρίς άδεια</li>
                  <li>Scraping ή αυτοματοποιημένη εξαγωγή δεδομένων</li>
                </ul>
              </div>
            </div>
            <p className="mt-3 text-sm"><strong>Συμβατικό Δίκαιο:</strong> Αυτοί οι όροι χρήσης διέπονται από το ελληνικό δίκαιο. Αρμόδια δικαστήρια είναι αυτά της Θεσσαλονίκης.</p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">Άρθρο 6. ΠΡΟΣΤΑΣΙΑ ΔΕΔΟΜΕΝΩΝ & ΣΥΜΜΟΡΦΩΣΗ ΓΚΠΔ</h3>
            <p className="mb-2">Οι νομικές σας ερωτήσεις επεξεργάζονται σύμφωνα με:</p>
            <ul className="list-disc list-inside mb-3 space-y-1">
              <li>ΓΚΠΔ Άρθρο 6(1)(β): Εκτέλεση σύμβασης για παροχή υπηρεσίας</li>
              <li>ΓΚΠΔ Άρθρο 6(1)(στ): Νόμιμα συμφέροντα για βελτίωση υπηρεσίας</li>
              <li>Νόμος 4624/2019: Ελληνική εφαρμογή του ΓΚΠΔ</li>
            </ul>
            <p className="text-sm">🔒 <strong>Τα δικαιώματά σας:</strong> Πρόσβαση, διόρθωση, διαγραφή, περιορισμός, φορητότητα δεδομένων και αντίρρηση σύμφωνα με τα άρθρα 15-21 του ΓΚΠΔ.</p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">Άρθρο 8. ΠΑΚΕΤΑ ΣΥΝΔΡΟΜΗΣ ΚΑΙ ΟΡΙΑ ΧΡΗΣΗΣ</h3>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="border border-slate-200 p-3 rounded">
                <h4 className="font-bold text-slate-900">🆓 Δοκιμαστικό — Δωρεάν</h4>
                <p className="text-sm">14 ημέρες πλήρης πρόσβαση · 10 AI αναλύσεις/ημέρα · Χωρίς κάρτα</p>
              </div>
              <div className="border border-green-200 p-3 rounded">
                <h4 className="font-bold text-green-700">💼 Επαγγελματικό — 199 € / μήνα</h4>
                <p className="text-sm">Για δικηγόρους · Απεριόριστες AI αναλύσεις · AADE · Conflict Check</p>
              </div>
              <div className="border border-purple-200 p-3 rounded">
                <h4 className="font-bold text-purple-700">🏢 Δικηγορικό Γραφείο — Κατόπιν επικοινωνίας</h4>
                <p className="text-sm">Για γραφεία με 2+ δικηγόρους · API · Priority Support</p>
              </div>
            </div>
            
            <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded">
              <h4 className="font-bold mb-2">💡 ΣΗΜΑΝΤΙΚΕΣ ΔΙΕΥΚΡΙΝΙΣΕΙΣ:</h4>
              <ul className="text-sm space-y-1">
                <li>• Οι τιμές του Εταιρικού πλάνου καθορίζονται κατόπιν ατομικής συμφωνίας</li>
                <li>• Ακύρωση συνδρομής ανά πάσα στιγμή — χωρίς δεσμεύσεις</li>
                <li>• Όλες οι τιμές και όρια υπόκεινται σε αλλαγές με προηγούμενη ειδοποίηση</li>
              </ul>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">Άρθρο 9. ΤΕΛΙΚΕΣ ΔΙΑΤΑΞΕΙΣ</h3>
            <p className="mb-2"><strong>Ρήτρα Διάσωσης:</strong> Εάν μεμονωμένες διατάξεις είναι άκυρες, η εγκυρότητα των υπόλοιπων διατάξεων παραμένει ανεπηρέαστη.</p>
            <p className="mb-4"><strong>Δικαίωμα Τροποποίησης:</strong> Διατηρούμε το δικαίωμα να τροποποιούμε αυτούς τους όρους οποτεδήποτε. Οι χρήστες θα ειδοποιούνται για αλλαγές μέσω email.</p>
            
            <div className="text-center p-4 bg-gray-100 border border-gray-300 rounded">
              <p className="font-bold">⚖️ Με τη χρήση της πλατφόρμας ΝΟΜΟΚΡΑΤΙΑ επιβεβαιώνετε ότι έχετε διαβάσει, κατανοήσει και αποδεχτεί πλήρως αυτούς τους όρους χρήσης. ⚖️</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">📞 Επικοινωνία & Νομικά Αιτήματα</h3>
            <div className="p-3 bg-gray-50 border border-gray-200 rounded">
              <p className="font-bold">PROTOS AI Agency IKE</p>
              <p>Αρχαιολογικού Μουσείου 17, 54640 Θεσσαλονίκη, Ελλάδα</p>
              <p>E-Mail: info@nomokratia.ai</p>
              <p>Website: www.nomokratia.ai</p>
              <p>ΑΦΜ: 802208607 | ΓΕΜΗ: 172146906000</p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};


export default TermsOfServiceModal;
